export const buttonStyles = {
  small: {
    base: `
      h-5
      py-[var(--component-button-size-small-padding-top)]
      px-[var(--component-button-size-small-padding-right)]
      rounded-[var(--component-button-size-small-border-radius)]
    `,
    iconOnly: `
      h-5
      py-[var(--component-button-size-small-padding-top)]
      px-[var(--component-button-size-small-padding-top)]
      rounded-[var(--component-button-size-small-border-radius)]
      relative
    `,
  },
  medium: {
    base: `
      h-6
      py-[var(--component-button-size-medium-padding-top)]
      px-[var(--component-button-size-medium-padding-right)]
      rounded-[var(--component-button-size-medium-border-radius)]
    `,
    iconOnly: `
      h-6
      py-[var(--component-button-size-medium-padding-top)]
      px-[var(--component-button-size-medium-padding-top)]
      rounded-[var(--component-button-size-medium-border-radius)]
      relative
    `,
  },
  large: {
    base: `
      h-8
      text-sm
      py-[var(--component-button-size-large-padding-top)]
      px-[var(--component-button-size-large-padding-right)]
      rounded-[var(--component-button-size-large-border-radius)]
    `,
    iconOnly: `
      h-8
      py-[var(--component-button-size-large-padding-top)]
      px-[var(--component-button-size-large-padding-top)]
      rounded-[var(--component-button-size-large-border-radius)]
      relative
    `,
  },
  xl: {
    base: `
      h-12
      text-sm
      py-[var(--component-button-size-xl-padding-top)]
      px-[var(--component-button-size-xl-padding-right)]
      rounded-[var(--component-button-size-xl-border-radius)]
    `,
    iconOnly: `
      h-12
      py-[var(--component-button-size-xl-padding-top)]
      px-[var(--component-button-size-xl-padding-top)]
      rounded-[var(--component-button-size-xl-border-radius)]
      relative
    `,
  },
  xxl: {
    base: `
      h-20
      py-[var(--component-button-size-xxl-padding-top)]
      px-[var(--component-button-size-xxl-padding-right)]
      rounded-[var(--component-button-size-xxl-border-radius)]
    `,
    iconOnly: `
      h-20
      py-[var(--component-button-size-xxl-padding-top)]
      px-[var(--component-button-size-xxl-padding-top)]
      rounded-[var(--component-button-size-xxl-border-radius)]
      relative
    `,
  },
  active: `
    !bg-[color:var(--component-button-primary-background-color-base)]
    !text-[color:var(--component-button-primary-font-color-base)]
  `,
  fill: `
    grow
  `,
  reverse: `
    flex-row-reverse
  `,
  square: {
    small: `
      w-5
    `,
    medium: `
      w-6
    `,
    large: `
      w-8
    `,
  },
}
